<script lang="ts">
  import LyNavigation from './LyNavigation.svelte';
  import LyLogo from './LyLogo.svelte';
  import { BreakpointService } from '../services/BreakpointService.svelte';

  const Breakpoint = new BreakpointService();
</script>

<aside class="LayoutSidebar lyInsetAbs">
  <LyLogo />
  {#if Breakpoint.isGreater('large')}
    <div class="LayoutNavInSidebar">
      <LyNavigation />
    </div>
  {/if}
</aside>

<style lang="scss">
  @use '../../styles/mixins';

  .LayoutSidebar {
    position: relative;
    top: auto;
    right: auto;
    bottom: auto;
    left: auto;
    z-index: 10;
    width: auto;
    height: auto;
    background: transparent;
    border: none;
    border-radius: 0;
    box-shadow: none;

    @include mixins.greaterSmall() {
      background: var(--layout-background);
      border: var(--border-basic);
      border-radius: var(--border-radius);
      box-shadow: var(--box-shadow-basic);
    }

    @include mixins.greaterLarge() {
      position: absolute;
      top: 0;
      left: 0;
      width: var(--sidebar-width);
      min-height: calc(4 * var(--outset-abs-doubled));
    }

    .LayoutNavInSidebar {
      display: block;
      margin-top: 1rem;
    }
  }
</style>
